import React, {Component} from 'react'
import ConfigureAssemblyPart from './configureassemblypart.component.jsx'
import './assemblyparts.scss'
import Icon from "../../icon/icon.component.jsx"

class ModalSearchAssemblyParts extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            configurations: [],
            initialConfigurations: [],
            assembly: this.props.assembly,
            calculatorResults: this.props.calculatorResults,
            hasCalculator: this.props.hasCalculator,
        }

        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.handleConfigurationChange = this.handleConfigurationChange.bind(this)
    }

    componentDidMount() {
        this.setState({
            initialConfigurations: this.props.initialAssemblyConfiguration,
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            assembly: nextProps.assembly,
            calculatorResults: nextProps.calculatorResults,
        })
    }

    handleConfigurationChange(conf) {
        let configurations = this.state.configurations
        if (this.state.configurations.filter(c => conf.partId === c.partId).length > 0) {
            configurations = this.state.configurations.map(c => {
                if (c.partId === conf.partId) {
                    return conf
                }
                return c
            })
        } else {
            configurations.push(conf)
        }

        this.setState({
            configurations: configurations
        }, () => {
            this.onChange(this.state.configurations)
        })
    }

    render() {
        return <div className="row assembly-parts pt-3 pb-1 mb-2">
            <div className="col-1">
                <span className="">
                    <Icon className={"assembly-parts-icon"} value={"cog"}/>
                </span>
            </div>
            <div className="col-11">
                {this.state.assembly.attributes.parts.map(part => {
                    let calculatedValue = ''
                    const values = this.state.calculatorResults.filter(r => r.partId === part.id)
                    if (values.length > 0) {
                        calculatedValue = values[0].result
                    }
                    let partChoiceId = ''
                    let measure = ''
                    const configs = this.state.initialConfigurations.filter(c => c.partId === part.id)
                    if (configs.length > 0) {
                        partChoiceId = configs[0].partChoiceId
                        measure = configs[0].measure
                    }
                    return <ConfigureAssemblyPart
                        hasCalculator={this.state.hasCalculator}
                        calculatedValue={calculatedValue}
                        part={part}
                        partChoiceId={partChoiceId}
                        measure={measure}
                        key={part.id}
                        onChange={this.handleConfigurationChange}
                    />
                })}
            </div>
        </div>
    }
}

export default ModalSearchAssemblyParts





// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/assemblyparts.component.jsx